import PubSub from "underpub-js";

var Header = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-Header',
	};

	$.extend(true, this.options, options);

};

Header.prototype.init = function() {

	var self = this;

	self.$logoImageLight = self.options.$el.find(`.${self.options.baseClass}__logo__image--light`);

	PubSub.subscribe('ModalNavigation:toggleOn', () => {
		self.$logoImageLight.addClass(`visible`);
	});

	PubSub.subscribe('ModalNavigation:toggleOff', () => {
		self.$logoImageLight.removeClass(`visible`);
	});

};

export default Header;
